(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var zoomableBlocks = document.querySelectorAll('.text-block--zoomable-images');

    if (!zoomableBlocks.length) return;

    var existingLightbox = document.querySelector('.text-block-image-lightbox');
    var lightbox = existingLightbox;

    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'text-block-image-lightbox';
      lightbox.innerHTML = `
        <button type="button" class="text-block-image-lightbox__close" aria-label="Close image">×</button>
        <img class="text-block-image-lightbox__image" src="" alt="">
      `;
      document.body.appendChild(lightbox);
    }

    var lightboxImage = lightbox.querySelector('.text-block-image-lightbox__image');
    var closeButton = lightbox.querySelector('.text-block-image-lightbox__close');

    zoomableBlocks.forEach(function (block) {
      var images = block.querySelectorAll('img');

      images.forEach(function (img) {
        if (img.closest('a')) return;
        if (img.dataset.zoomPrepared === 'true') return;

        var src = img.getAttribute('src');
        if (!src) return;

        var cleanSrc = src.split('?')[0];

        var link = document.createElement('a');
        link.href = cleanSrc;
        link.className = 'text-block__image-zoom';
        link.setAttribute('aria-label', 'Open image');

        img.parentNode.insertBefore(link, img);
        link.appendChild(img);

        img.dataset.zoomPrepared = 'true';

        link.addEventListener('click', function (event) {
          event.preventDefault();
          lightboxImage.src = this.href;
          lightbox.classList.add('is-open');
          document.body.classList.add('text-block-lightbox-open');
        });
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightboxImage.src = '';
      document.body.classList.remove('text-block-lightbox-open');
    }

    closeButton.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
